import _classCallCheck from "/Users/hart/dev/applications/personal-website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/hart/dev/applications/personal-website/node_modules/@babel/runtime/helpers/esm/createClass.js";
export var EventDispatcher = /*#__PURE__*/function () {
  function EventDispatcher() {
    _classCallCheck(this, EventDispatcher);

    this._listeners = new Map();
  }

  _createClass(EventDispatcher, [{
    key: "addEventListener",
    value: function addEventListener(type, listener) {
      var _a;

      this.removeEventListener(type, listener);

      if (!this._listeners.get(type)) {
        this._listeners.set(type, []);
      }

      (_a = this._listeners.get(type)) === null || _a === void 0 ? void 0 : _a.push(listener);
    }
  }, {
    key: "dispatchEvent",
    value: function dispatchEvent(type, args) {
      var _a;

      (_a = this._listeners.get(type)) === null || _a === void 0 ? void 0 : _a.forEach(function (handler) {
        return handler(args);
      });
    }
  }, {
    key: "hasEventListener",
    value: function hasEventListener(type) {
      return !!this._listeners.get(type);
    }
  }, {
    key: "removeAllEventListeners",
    value: function removeAllEventListeners(type) {
      if (!type) {
        this._listeners = new Map();
      } else {
        this._listeners.delete(type);
      }
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(type, listener) {
      var arr = this._listeners.get(type);

      if (!arr) {
        return;
      }

      var length = arr.length,
          idx = arr.indexOf(listener);

      if (idx < 0) {
        return;
      }

      if (length === 1) {
        this._listeners.delete(type);
      } else {
        arr.splice(idx, 1);
      }
    }
  }]);

  return EventDispatcher;
}();